<template>
  <div class="billManagement">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px" size="mini" style="width: 100%;">
        <div class="formItemBox">
        <el-form-item label="创建时间:">
          <div style="display: flex;">
          <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.createTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结算客户:">
          <!-- <el-input v-model="formData.payCustomerName"  placeholder="请输入" size="mini" style="width:135px;vertical-align:top;"></el-input> -->
          <el-select v-model="formData.payCustomerNameTaxId" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.itemNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算状态:">
          <el-select v-model="formData.feeState" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item, index) in jiesuanOptions" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账单编号:">
          <el-input v-model="formData.feeNo" placeholder="请输入" size="mini">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="账期:">
          <el-date-picker v-model="formData.billStartDate" size="mini" type="date"
            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.billEndDate" size="mini" type="date"
            value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item> -->
        </div>
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[27]" btnCode="003M320T00">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[28]" btnCode="003M320U00">重置</el-button>

        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column width="150" label="操作" align="center">
          <template v-slot="scope">
            <el-button v-if="btnFlg[29]" btnCode="003M320V00" type="text" @click="addzhangdan(scope.row,scope.row.feeMasterId)">账单明细</el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeNo" label="账单号" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payCustomerName" label="结算客户" align="center" width="220">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivableFee" label="应收金额" align="center" width="120">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeStateName" label="状态" align="center" width="100">
          <template v-slot="scope">
            <span style='color:red;' v-if="scope.row.feeStateName == '未收款'">{{scope.row.feeStateName}}</span>
            <span v-else>{{scope.row.feeStateName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="accountPeriod" label="账期" align="center" width="150">
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="账单备注" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="feeRemark" label="费用备注" align="center" width="150">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="billStartDate" label="账单开始日" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="billEndDate" label="账单结束日" align="center" width="150">
        </el-table-column> -->

        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" width="150">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="200">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payPerson" label="付款人" align="center" width="200">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payTime" label="付款时间" align="center" width="200">
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="sheets" label="张数" align="center" width="120">
        </el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" prop="completeTime" label="结算完成时间" align="center" width="200"></el-table-column> -->
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
    <el-dialog v-loading="loading" title="账单明细" :visible.sync="zhangdanDetailVisible" :close-on-click-modal="false" width="90%" center :before-close="guanbi">
      <p>
        <span>费用合计：<span style="color:red">{{totalFee}}</span> 元</span>
        <span class="box">附加：<span style="color:red">{{additionalFee}}</span> 元</span>
        <span class="box">减免：<span style="color:red">{{deductionFee}}</span> 元</span>
        <span class="box">应收：<span style="color:red">{{YStotalFee}}</span> 元</span>
        <span class="box">费用备注：<span>{{feeRemark}}</span></span>
      </p>
      <hr>
      <div v-if="JBShow">
        <el-table height="200px" size="mini" border center bordersize="mini" ref="tabref1" :data="tableDataMX" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用项目" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="pricingMethod" label="计价方式" align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeVolume" label="结算量" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="fee" label="金额" align="center"></el-table-column>
        </el-table>
      </div>
      <div>
        <p>费用明细：</p>
        <div v-if="JBShow">
          <el-table height="300px" size="mini" border center bordersize="mini" ref="table" :data="feeDetailList" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
            <el-table-column v-if="feeDetailList.length>0" type="index" align="center" label="序号" width="60">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName" :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center" :width="item.titleId=='cargoBarcode'||item.titleId=='customerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='inCustomerName'?200:120">
              <template v-if="item.titleId instanceof Array ? true : false">
                <el-table-column v-for="item in item.titleId" :key="item.titleId" :prop="item.titleId" :label="item.titleName"></el-table-column>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table height="300px" size="mini" border center bordersize="mini" ref="table" :data="MXDataJC" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row>
            <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="总重量（吨）" align="center" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="250"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号" align="center" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="businessType" label="业务类型" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="businessTime" label="业务时间" align="center" width="180">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inRansportMethod" label="到货方式" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="guanbi">关闭</el-button>
      </div>
    </el-dialog>
    <!--点击查看凭证-->
    <div class="addMarkBox">
      <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="60%" center>
        <!-- <div v-if="!imgFlag">
            <div>无货损图片</div>
          </div>-->
        <div class="img_box">
          <div v-for="(item, index) in imgData" :key="index">
            <img :src="item.url" alt />
            <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)"></i> -->
            <i class="el-icon-zoom-in" @click="handChange(item.url)"></i>
          </div>
        </div>
        <el-dialog class="oneTwo" :visible.sync="dialogVisible" title="查看凭证" append-to-body width="40%" center :close-on-click-modal="false">
          <div class="imgDialog">
            <img :src="imageD" alt />
          </div>
        </el-dialog>
        <div style="width: 158px; margin: 15px auto"></div>
      </el-dialog>
    </div>
    <billsDetail v-if="zhangdanDetailVisibles" :zhangdanDetailVisible.sync="zhangdanDetailVisibles" :feeMasterId="feeMasterId"></billsDetail>
  </div>
</template>

<script>
import {
  JfgetFeeMasterList,
  JfgetStorageFeeList,
  JfdeleteFeeMaster,
  JfcompleteStorageFee,
  getFeeList,
  deleteJCFeeMaster,
  getJCFeeList,
  finishJCFee
} from '@/api/wms-stock'

import {
  exportExcel
} from '@/utils/fileDown.js'
import DonMessage from '@/utils/message'
import {
  getCargoDamagePicture // 查看图片
} from '@/api/wms-access'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import {
  getBtn
} from '@/utils/getButton'

import billsDetail from '@/views/wms-stock/cangChu/jiesuan/billsDetail.vue'
export default {
  name: 'billManagement',
  components: {
    billsDetail
  },
  data () {
    return {
      formData: {
        createTimeStart: '',
        createTimeEnd: '',
        billStartDate: '',
        billEndDate: '',
        payCustomerNameTaxId: '',
        feeState: '0',
        feeNo: ''
      },
      pageInfo: {
        feeType: '1',
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      jiesuanOptions: [{
        id: '',
        name: '全部'
      },
      {
        id: '0',
        name: '未收款'
      },
      {
        id: '1',
        name: '已收款'
      }
      ],
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      zhangdanDetailVisible: false,
      loading: false,
      DetailtableData: [],
      tableDataMX: [],
      // feeDetailList: { cargoList: [], titleList: [] },
      feeDetailList: [],
      titleList: [],
      feeNo: '',
      payCustomerName: '',
      feeStateName: '',
      remark: '',
      storageFee: '',
      additionalFee: '',
      deductionFee: '',
      totalFee: '',
      YStotalFee: '',
      feeRemark: '',
      addMarkLookBox: false,
      imageD: '',
      dialogVisible: false,
      imgData: [],
      keHuOptions: [],
      btnFlg: [],
      btnIdArr: [
        '003M320200',
        '003M320300',
        '003M320400',
        '003M320500',
        '003M320600',
        '003M320700',
        '003M320800',
        '003M320900',
        '003M320A00',
        '003M320B00',
        '003M320C00',
        '003M320D00',
        '003M320E00',
        '003M320F00',
        '003M320G00',
        '003M320H00',
        '003M320I00',
        '003M320J00',
        '003M320K00',
        '003M320L00',
        '003M320M00',
        '003M320N00',
        '003M320O00',
        '003M320P00',
        '003M320Q00',
        '003M320R00',
        '003M320S00',
        '003M320T00',
        '003M320U00',
        '003M320V00'

      ],
      zhangdanDetailVisibles: false,
      feeMasterId: '',
      feeMasterTotal: 0,
      feeMasterTotalNo: 0,
      feeMasterTotalYes: 0,
      JBShow: true,
      MXDataJC: []
    }
  },
  methods: {
    // 查看凭证-放大
    handChange (url) {
      this.imageD = url
      this.dialogVisible = true
    },
    // 图片查看
    imgShow (row) {
      this.addMarkLookBox = true
      getCargoDamagePicture({
        cargoId: row.cargoId // 货物id
      })
        .then((res) => {
          this.imgData = []
          this.imgData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    chaxun () {
      JfgetFeeMasterList({
        ...this.pageInfo,
        ...this.formData,
        organizationId: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.xuanzhongArr = null
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    chongzhi () {
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.formData.billStartDate = ''
      this.formData.billEndDate = ''
      this.formData.payCustomerNameTaxId = ''
      this.formData.feeState = '0'
      this.formData.feeNo = ''
      this.pageInfo.feeType = '1'

      this.chaxun()
      this.getQueryCusterData()
    },
    xinzeng () {
      this.$router.push({
        path: '/addjiesuan'
      })
    },
    xinzengJc () {
      this.$router.push({
        path: '/addjiesuanJc'
      })
    },
    xiugai () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选中一条数据',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.feeType == 1) {
        this.$message.error('该账单为盘库账单，不能修改')
        return
      } else if (this.xuanzhongArr.feeStateName != '未收款') {
        this.$message({
          message: '该状态不可修改',
          type: 'error'
        })
        return
      }
      if (this.xuanzhongArr.feeType == '' || this.xuanzhongArr.feeType == '0') {
        this.$router.push({
          path: '/addjiesuan',
          query: {
            feeNo: this.xuanzhongArr.feeNo,
            payCustomerNameTaxId: this.xuanzhongArr.payCustomerNameTaxId,
            feeStateName: this.xuanzhongArr.feeStateName,
            remark: this.xuanzhongArr.remark,
            storageFee: this.xuanzhongArr.totalFee,
            additionalFee: this.xuanzhongArr.additionalFee,
            deductionFee: this.xuanzhongArr.deductionFee,
            totalFee: this.xuanzhongArr.totalFee,
            YStotalFee: this.xuanzhongArr.receivableFee,
            feeRemark: this.xuanzhongArr.feeRemark,
            feeMasterId: this.xuanzhongArr.feeMasterId
          }
        })
      } else if (this.xuanzhongArr.feeType == '2') {
        this.$router.push({
          path: '/addjiesuanJc',
          query: {
            feeNo: this.xuanzhongArr.feeNo,
            payCustomerNameTaxId: this.xuanzhongArr.payCustomerNameTaxId,
            payCustomerName: this.xuanzhongArr.payCustomerName,
            feeStateName: this.xuanzhongArr.feeStateName,
            remark: this.xuanzhongArr.remark,
            storageFee: this.xuanzhongArr.totalFee,
            additionalFee: this.xuanzhongArr.additionalFee,
            deductionFee: this.xuanzhongArr.deductionFee,
            totalFee: this.xuanzhongArr.totalFee,
            YStotalFee: this.xuanzhongArr.receivableFee,
            feeRemark: this.xuanzhongArr.feeRemark,
            feeMasterId: this.xuanzhongArr.feeMasterId
          }
        })
      }
    },
    daochu () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选择一条数据',
          type: 'error'
        })
        return
      }
      if (this.xuanzhongArr.feeType == 1) {
        this.$message.error('该账单为盘库账单，不能导出')
        return
      }
      if (this.xuanzhongArr.feeType == 2) {
        exportExcel(
          this.global.wmsStockName + '/storageFee/exportJCStorageFeeList', {
            ...this.formData,
            feeMasterId: this.xuanzhongArr.feeMasterId
          },
          '账单管理'
        )
      } else {
        exportExcel(
          this.global.wmsStockName + '/storageFee/exportStorageFeeList', {
            ...this.formData,
            feeMasterId: this.xuanzhongArr.feeMasterId
          },
          '账单管理'
        )
      }
    },
    shanchu () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选中一条数据',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.feeType == 1) {
        this.$message.error('该账单为盘库账单，不能删除')
        return
      }
      this.$confirm('删除后不可恢复，确认删除吗？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (this.xuanzhongArr.feeType == 2) {
          deleteJCFeeMaster({
            feeMasterId: this.xuanzhongArr.feeMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('删除成功')
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        } else {
          JfdeleteFeeMaster({
            feeMasterId: this.xuanzhongArr.feeMasterId
          }).then(res => {
            this.$message.success('删除成功')
            this.chaxun()
          }).catch(err => {
            DonMessage.error(err.message)
          })
        }
      }).catch(() => { })
    },
    finished () {
      if (this.xuanzhongArr == null) {
        this.$message({
          message: '请先选中一条数据',
          type: 'error'
        })
        return
      } else if (this.xuanzhongArr.feeType == 1) {
        this.$message.error('该账单为盘库账单，不能结算完成')
        return
      }
      this.$confirm('结算完成后不可更改，确认结算完成吗？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        if (this.xuanzhongArr.feeType != 2) {
          JfcompleteStorageFee({
            feeMasterId: this.xuanzhongArr.feeMasterId
          }).then(res => {
            this.$message.success('结算成功')
            this.chaxun()
          }).catch(err => {
            DonMessage.error(err.message)
          })
        } else {
          finishJCFee({
            feeMasterId: this.xuanzhongArr.feeMasterId
          }).then(res => {
            console.log(res)
            this.$message.success('结算成功')
            this.chaxun()
          })
            .catch(error => {
              this.$message.error(error.message)
            })
        }
      }).catch(() => { })
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    getFeeList (row) {
      getFeeList({
        feeMasterId: row.feeMasterId
      })
        .then(res => {
          this.zhangdanDetailVisible = true
          this.tableDataMX = res.feeUpList
          console.log(res)
          this.feeDetailList = res.feeList
          this.titleList = res.titleList
          // if (res.length > 0) {
          //   this.tableDataMX = res
          //   this.feeDetailList = res[0].listmap
          // }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 账单明细
    addzhangdan (row, val) {
      if (row.feeType == '1') {
        this.zhangdanDetailVisibles = true
        this.inventoryDivideId = row.inventoryDivideId
        this.feeMasterId = row.feeMasterId
        this.inventoryMasterId = row.inventoryMasterId
        return
      }
      if (row.feeType == '' || row.feeType == '0') {
        this.getFeeList(row)
      } else if (row.feeType == 2) {
        this.JBShow = false
        getJCFeeList({
          feeMasterId: row.feeMasterId
        }).then(res => {
          console.log(res)
          this.zhangdanDetailVisible = true
          this.MXDataJC = res
        })
          .catch(error => {
            this.message.error(error.message)
          })
      }

      // this.feeNo = row.feeNo
      // this.payCustomerName = row.payCustomerName
      // this.feeStateName = row.feeStateName
      // this.remark = row.remark
      // this.storageFee = row.storageFee
      this.additionalFee = row.additionalFee
      this.deductionFee = row.deductionFee
      this.totalFee = row.totalFee
      this.YStotalFee = row.receivableFee
      this.feeRemark = row.feeRemark
      // JfgetStorageFeeList(
      //   {
      //     feeMasterId: val
      //   }
      // )
      //   .then(res => {
      //     console.log(res)
      //     this.DetailtableData = res
      //     // this.total = res.total
      //   })
      //   .catch(error => {
      //     this.$message({ message: error.message, type: 'error' })
      //   })
    },
    guanbi () {
      this.zhangdanDetailVisible = false
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      let h = this.$refs.searchBox.offsetHeight
      let pH = document.documentElement.clientHeight
      this.h = pH - h - 210 + 'px'
    })
    this.btnFlg = getBtn(this.btnIdArr, '/billManagement')
    console.log(this.btnFlg, 'this.btnFlg')
    console.log(this.btnFlg[0], 'this.btnFlg0000')
    this.chaxun()
    this.getQueryCusterData()
  }
}

</script>

<style lang="less" scoped>
.box {
  margin-left: 30px;
}

/deep/ .el-form-item {
  margin-bottom: 0px;
}

  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
